window.EventBus = new Vue();

const routes = [
    {
        path: '/:family/general',
        component: General,
        name: 'General'
    },
    {
        path: '/:family/competitors',
        component: Competitors,
        name: 'Competitors',
        beforeEnter: (to, from, next) => {
            if (!store.state.pa) {
                store.dispatch('GET_ASSIGNEE', to.params.family)
                    .then(res => {
                        console.log(res);
                        next();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                next();
            }
        }
    },
    {
        path: '/:family/technologies',
        component: Technologies,
        name: 'Technologies'
    },
    {
        path: '/:family/assignee',
        component: AssigneeInfos,
        name: 'Assignee',
        beforeEnter: (to, from, next) => {
            if (!store.state.pa) {
                store.dispatch('GET_ASSIGNEE', to.params.family)
                    .then(res => {
                        console.log(res);
                        next();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                next();
            }
        }
    },
    {
        path: '/:family/inventors',
        component: Inventors,
        name: 'Inventors'
    },
    {
        path: '/:family/legal',
        component: Legal,
        name: 'Legal'
    },
    {
        path: '/:family/pvs',
        component: PVS,
        name: 'PVS'
    },    
    {
        path: '/:family/assignees/:assigneeName',
        component: AssigneeInfos
    },
    {
        path: '/:family/technologies/:system/:class',
        component: ClassDescription
    },
    {
        path: '/:family/inventors/:inventor',
        component: InventorInfos
    },
    {
        path: '/:family',
        redirect: '/:family/general'
    },
    {
        path: '/',
        component: NoFamily
    }
];

const router = new VueRouter({
    routes // short for `routes: routes`
});

router.beforeEach((to, from, next) => {

    if (!store.getters.loadedComponents.find(compo => compo == to.name)) {
        store.commit('showLoading');
    } else {
        store.commit('hideLoading');
    }

    next();
})

//main vue instance
new Vue({
    el: '#app',
    store: store,
    router,
    data: {
        isLoading: true,
        showSideMenu: false
    },

    watch: {

        '$route.params.family'(to, from) { //listen for family change
            this.$store.commit('resetStore');
            EventBus.$emit('newFamily');
            EventBus.$emit('showLoading');
        }

    },

    methods: {
        toggleSideMenu: function() {
            this.showSideMenu = !this.showSideMenu;
        },

        closeDescription(e) {
            if ($(e.target).parents('#descriptionTooltip').length == 0) {
                EventBus.$emit('closeDescription');
            }
        }
    }
});
